/**
 * HelpNoticeDetailsContainer
 * --
 */
import React from 'react';
import HelpNoticeDetailsPresenter from './HelpNoticeDetailsPresenter';
import { useParams } from 'react-router-dom';
import { useGetNotice } from 'hooks/NoticeHooks';
import { decrypt } from 'utils/Crypto';

const HelpNoticeDetailsContainer = (props) => {
  /* ===== ROUTE ===== */
  const { noticeId } = useParams();

  // 공지사항 idx
  const NoticeIdx = React.useMemo(() => {
    const decodeIdx = decrypt(noticeId);
    return Number(decodeIdx);
  }, [noticeId]);

  /* ===== PROPS ===== */
  const { navigate, screenSize } = props;

  /* ===== Data ===== */
  const { data: notice } = useGetNotice(NoticeIdx, null, {
    select: (res) => {
      if (res.status !== 200) return null;

      return res.data;
    },
    enabled: !!NoticeIdx,
  });

  /* ===== Store ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <HelpNoticeDetailsPresenter
        navigate={navigate}
        notice={notice}
        screenSize={screenSize}
      />
    </>
  );
};

export default HelpNoticeDetailsContainer;
